<script setup lang="ts">
import { usePartnerPlaylistStore } from '~~/stores/partnerplaylist'

const route = useRoute()
const router = useRouter()

const { email, groupSerial, token } = route.query

const { activatePartnerPlaylistMember } = usePartnerPlaylistStore()

onMounted(() => {
  activatePartnerPlaylistMember({
    payload: {
      email,
      groupSerial,
      token
    },
    resolve: () => {
      router.replace('/signin')
    }
  })
})
</script>

<template>
  <div class="container mt-6">
    <img
      src="~/assets/images/logo-kognisi.svg"
      width="182"
      alt="kognisi logo"
      loading="lazy"
    />
  </div>
  <div class="container h-[80vh] flex justify-center">
    <div class="flex flex-col justify-center items-center">
      <div>
        <img
          src="~/assets/images/ilustrasi-join-partnergroup.svg"
          width="262"
          alt="ilustrasi"
          loading="lazy"
        />
      </div>
      <div class="font-bold text-3xl mb-4 mt-2">Anda Tervalidasi</div>
      <div class="mb-2">
        Kami akan bawa anda ke halaman login, jangan tutup halaman ini
      </div>
      <div>
        <img
          src="~/assets/animations/dotted-loading.gif"
          width="100px"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>
